'use client';
import React from 'react';
import Script from 'next/script';
import { OllieTheme, GlobalStyle } from '@ui/theme';
import { ExperimentProvider } from '../experiments/index';
import { Reporter, ReporterProvider } from '../reporter';
import { ToastProvider } from '../Toast/ToastProvider';
import { OfferProvider } from '../offer/appContext';
import { CampaignProvider } from '../campaign/appContext';
import { ApiProvider } from '../api';
import { ErrorBoundary } from '../containers/ErrorPage/ErrorBoundary';
import { GladlyContainer } from '../gladly/appContainer';
import { StripeElementsProvider } from '../payment';
import { EnvProvider } from './contexts/EnvContext';
import { StyledComponentsRegistry } from './StyledComponentRegistry';

const ClientProviders = ({
  envVars,
  initialSession,
  flagshipData,
  gladlyDisplayRules,
  children,
}) => {
  const reporter = new Reporter();
  return (
    <EnvProvider envVars={envVars}>
      <ApiProvider initialSession={initialSession} appRouter={true}>
        <ReporterProvider reporter={reporter}>
          <StyledComponentsRegistry>
            <OllieTheme>
              <ToastProvider>
                <ExperimentProvider flagshipData={flagshipData}>
                  <CampaignProvider>
                    <OfferProvider>
                      <StripeElementsProvider>
                        <GlobalStyle />
                        <ErrorBoundary reporter={reporter}>
                          {children}
                        </ErrorBoundary>
                        <GladlyContainer
                          gladlySettings={{ displayRules: gladlyDisplayRules }}
                        />
                        <Script src="https://www.googletagmanager.com/gtag/js?id=G-H1JV5JVL6B" />
                        <Script id="google-analytics">
                          {`
                          window.dataLayer = window.dataLayer || [];
                          function gtag(){dataLayer.push(arguments);}
                          gtag('js', new Date());

                          gtag('config', 'G-H1JV5JVL6B');
                        `}
                        </Script>
                      </StripeElementsProvider>
                    </OfferProvider>
                  </CampaignProvider>
                </ExperimentProvider>
              </ToastProvider>
            </OllieTheme>
          </StyledComponentsRegistry>
        </ReporterProvider>
      </ApiProvider>
    </EnvProvider>
  );
};

export default ClientProviders;
